module.exports = __webpack_public_path__ + "img/home_bg_03_1.1cb82794.png";